import { TaskLog } from "../../types/TaskLog";
import { TaskLogActions, TaskLogActionList } from "../actions/taskLogActions";

const initialState: TaskLog[] = [];

export const taskLogReducer = (
  state: TaskLog[] = initialState,
  action: TaskLogActions,
): TaskLog[] => {
  switch (action.type) {
    case TaskLogActionList.ADD_TASK_LOG:
      return [...state, action.data];

    case TaskLogActionList.EDIT_TASK_LOG:
      return state.map((log) =>
        log.id === action.data.id ? { ...action.data } : log,
      );

    case TaskLogActionList.FETCH_TASK_LOGS:
      return action.data;

    case TaskLogActionList.DELETE_TASK_LOG:
      return state.filter((log) => log.id !== action.data);

    default:
      return state;
  }
};
